// Iglooworks devices = the resident's BLE door keys. Flat-array response, backward-compatible
// with shipped clients (legacy web + released mobile). PIN state lives on a separate endpoint
// (see normalize-igloo-pin) — the two are never mixed into one wrapped response.
// Note: startDate/endDate are unix ms and are absent on older backends — the door-edit UI falls
// back to the lease dates when the resident's keys carry no end date of their own.
export type IglooKey = { id: string; name: string; startDate?: number; endDate?: number }

type RawIglooKey = {
  id: string | number
  name: string
  key?: string
  startDate?: number | string | null
  endDate?: number | string | null
}

export type RawIglooDevices = RawIglooKey[] | null | undefined

export type IglooDevices = { keys: IglooKey[] }

const toTimestamp = (value: number | string | null | undefined): number | undefined => {
  if (value === null || value === undefined || value === '') return undefined
  const ms = typeof value === 'number' ? value : Number(value)
  return Number.isFinite(ms) ? ms : undefined
}

export const getEarliestKeyExpiry = (
  keys: ({ endDate?: number | string | null } | null | undefined)[] | null | undefined,
): number | undefined => {
  const expiries = (Array.isArray(keys) ? keys : [])
    .map((key) => toTimestamp(key?.endDate))
    .filter((ms): ms is number => ms !== undefined && ms > 0)
  return expiries.length ? Math.min(...expiries) : undefined
}

export const normalizeIglooDevices = (raw: RawIglooDevices): IglooDevices => ({
  keys: (Array.isArray(raw) ? raw : []).map((k) => {
    const startDate = toTimestamp(k.startDate)
    const endDate = toTimestamp(k.endDate)
    return {
      id: String(k.id),
      name: k.name,
      ...(startDate === undefined ? {} : { startDate }),
      ...(endDate === undefined ? {} : { endDate }),
    }
  }),
})
